// removed by extract-text-webpack-plugin
module.exports = {"avatarUploader":"style__avatarUploader__3INLV","avatarUploaderTrigger":"style__avatarUploaderTrigger__2-d3O","avatar":"style__avatar__3xslO","satUploader":"style__satUploader__2kwlz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OrderForm/FieldTemplates/ImagesFieldTemplate/style.less
// module id = 1293
// module chunks = 0